import { render } from "./App.vue?vue&type=template&id=b62bd234"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/main.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=b62bd234&lang=scss"

import exportComponent from "../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__